// src/features/services/components/ServiceActions.tsx
import { WorkspaceActionItem } from '../../../app/components/foundation';

/**
 * Service actions section — presentation only. Items are disabled
 * placeholders; no click business logic is wired up here.
 */
export function ServiceActions() {
  return (
    <>
      <WorkspaceActionItem
        label="تمدید سرویس"
        variant="primary"
        disabled
        className="!text-[10px] !font-normal"
      />
      <WorkspaceActionItem
        label="مدیریت مشتری"
        variant="neutral"
        disabled
        className="!text-[10px] !font-normal"
      />
      <WorkspaceActionItem
        label="عملیات آینده"
        variant="neutral"
        disabled
        className="!text-[10px] !font-normal"
      />
    </>
  );
}
